import { FunctionComponent, memo } from 'react';
import { StoryCardEditorialContent } from '../../../../services';
import { HorizontalStoryFeedCardProps, HorizontalStoryFeedContentCommon } from '../../../../shared';
import { HorizontalStoryFeedCardWrapper } from '../HorizontalStoryFeedCardWrapper';

export const HorizontalStoryFeedEditorial: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const { content, isPinnedToTopOfNewsFeed, isPinnedToTopOfStory } = card;
    const { sourceName, headline, subHeadline, text, textHTML } =
      content as StoryCardEditorialContent;

    return (
      <HorizontalStoryFeedCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          source={sourceName}
          title={headline}
          subTitle={subHeadline}
          text={text}
          htmlText={textHTML}
        ></HorizontalStoryFeedContentCommon>
      </HorizontalStoryFeedCardWrapper>
    );
  }
);
